import Vue from 'vue';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies)
Vue.use(Loading);

import * as moment from 'moment';
import 'moment/locale/nb'  // without this line it didn't work
moment.locale('nb')

Vue.filter('formatDate', function (value) {
    if (value) {
        var start = moment(String(value)).local();

        return moment(start).fromNow(); 
    }
    return 'Ukjent'
});

Vue.filter('toTons', function (value) {
    if (value < 1000) {
        return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kg';
    }
    else if (value < 10000) {
        return (value / 1000).toFixed(1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' tonn';
    }
    return Math.round(value / 1000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' tonn';
});

var app = new Vue({
    el: '#tempHome',

    components: {
        Loading
    },

    data: {
        lastDeliveries: [],
        topMunicipalites: []

    },

    computed: {

    },

    watch: {
        lastDeliveries: function (val) {
            //console.log(val);
        },
    },

    methods: {
        getLastDeliveries: function () {
            axios.get('/umbraco/Surface/Map/GetLastReceptions/')
                .then((response) => {
                    if (response.data !== 'error') {
                        //console.log(response.data);
                        this.lastDeliveries = response.data;
                        this.saveLastDeliveries();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getTopMunicipalities: function () {
            axios.get('/umbraco/Surface/Map/GetMunicipalitiesSummary/', { params: { selectThree: true } })
                .then((response) => {
                    if (response.data !== 'error') {
                        //console.log(response.data);
                        this.topMunicipalites = response.data;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        saveLastDeliveries: function () {
            try {
                var self = this;
                var deliveries = self.lastDeliveries.map(delivery => ({ date: delivery.date, registrationMark: delivery.registrationMark, warehouseName: delivery.warehouseName }));

                self.$cookies.set('_rflLastDeliveries', JSON.stringify(deliveries), "10min");

            } catch (e) {
                console.log('error saving deliveries')
            }
        },

        tryLoadLastDeliveries: function () {
            var self = this;
            try {
                var lastDeliveries = self.$cookies.get("_rflLastDeliveries");
                if (lastDeliveries && lastDeliveries !== null) {
                    lastDeliveries = $.parseJSON(lastDeliveries);
                    self.lastDeliveries = lastDeliveries;
                }
                else {
                    this.getLastDeliveries();
                }

            } catch (e) {
                this.getLastDeliveries();
                console.log('error reading deliveries')
            }
        },
    },

    created() {

    },

    mounted() {
        this.tryLoadLastDeliveries();
    }
});


// WEBPACK FOOTER //
// ./Scripts/app/homePage/index.js